var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal",
    {
      attrs: {
        "show-modal": _vm.showModal,
        "backdrop-class": "z-login-modal",
        "trigger-class-modal": "modal-sm pb-2",
        "close-button": true,
        "blur-modal-layout": "",
      },
      on: { close: _vm.goBackToLogin },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("span", { staticClass: "text-h3" }, [
                _vm._v(_vm._s(_vm.$t("App.LoginModal.sessionExpired"))),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.hasError
        ? _c(
            "warning-box",
            { attrs: { type: "error", "is-content-centered": "" } },
            [
              _c(
                "div",
                { staticClass: "flex flex-col" },
                [
                  _vm._l(_vm.errorMessages, function (message, id) {
                    return _c("span", { key: id }, [
                      _vm._v(" " + _vm._s(message) + " "),
                    ])
                  }),
                  _vm.lockoutWarningMessage
                    ? _c("div", [
                        _vm._v(" " + _vm._s(_vm.lockoutWarningMessage) + " "),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _c("login-form", {
        staticClass: "mb-2",
        on: { logged: _vm.onLoginSuccess, loginError: _vm.displayLoginError },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }